import ChartParametersFormattingStrategy from './ChartParametersFormattingStrategy'
import SingleDateFormattingStrategy from '../../../parametersFormatting/SingleDateFormattingStrategy'

export default class BalanceParametersFormattingStrategy extends ChartParametersFormattingStrategy {
    init({selectorsData, dateFormat, reportAuthorizationInfo}) {
        super.init({selectorsData, dateFormat, reportAuthorizationInfo})
        return this
    }

    createDateParametersFormattingStrategy(config) {
        return new SingleDateFormattingStrategy(config.dateFormat)
    }

    formatParametersText(selectedParameters){
        return this.parametersFormatter.formatUsersSelection(selectedParameters.hierarchicalSelectorsParameters.userSelection)
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/parametersFormatters/BalanceParametersFormattingStrategy.js